<script>
    import axios from 'axios'
    import AppMixin from './../../../mixins/AppMixin'
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import InputNumber from "primevue/inputnumber";
    import RadioButton from "primevue/radiobutton";
    import Divider from "primevue/divider";

    export default {
        mixins: [AppMixin],
        data() {
            return {
                loading: false,
                error: null,
                model: {}
            }
        },
        props: ["name", "uid", "type"],
        methods: {
            save() {
                let self = this;

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: self.model,
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.error = null
            },
            onOpen() {
                this.model = {
                    conditionOr: true,
                    targetNode: -2,
                };
            }
        },
        computed: {
            getApiUrl() {
                return this.$config.API_URL + '/clustering/' + this.uid + '/' + this.type + '/filter_group' ;
            },
            btnModalLabel() {
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            filterLabel() {
                return this.type === 'import' ? this.$t('lang.cluster.add_group_run') : this.$t('lang.cluster.delete_group_run');
            },

            resultStr() {
                let result = [], interResult = [];

                let config = {
                    [this.$t('lang.cluster.common_key_count')]: [
                        {condition: '<=', field: 'keysCountLess'}, {condition: '>=', field: 'keysCountMore'},
                    ],
                    [this.$t('lang.cluster.summ_ws')]: [
                        {condition: '<=', field: 'wsSumLess'}, {condition: '>=', field: 'wsSumMore'},
                    ],
                    [this.$t('lang.cluster.summ_wsk')]: [
                        {condition: '<=', field: 'wskSumLess'}, {condition: '>=', field: 'wskSumMore'},
                    ],
                    [this.$t('lang.cluster.summ_superwsk')]: [
                        {condition: '<=', field: 'superwskSumLess'}, {condition: '>=', field: 'superwskSumMore'},
                    ],
                    [this.$t('lang.cluster.ws_main_key')]:  [
                        {condition: '<=', field: 'wsMaxLess'}, {condition: '>=', field: 'wsMaxMore'},
                    ],
                    [this.$t('lang.cluster.wsk_main_key')]: [
                        {condition: '<=', field: 'wskMaxLess'}, {condition: '>=', field: 'wskMaxMore'},
                    ],
                    [this.$t('lang.cluster.superwsk_main_key')]: [
                        {condition: '<=', field: 'superwskMaxLess'}, {condition: '>=', field: 'superwskMaxMore'},
                    ]
                };

                for (let prop in config) {
                    config[prop].forEach((c) => {
                        if(this.model.hasOwnProperty(c.field) && this.model[c.field] !== ""){
                            interResult.push(prop + " " + c.condition + " " + this.model[c.field]);
                        }
                    });

                    if(interResult.length > 0){
                        result.push("(" + interResult.join(" " + this.$t('lang.main.filter.and') + " ") + ")");
                        interResult = [];
                    }

                }


                if(result.length === 0){
                    return null;
                }

                return "(" + result.join(this.model.conditionOr ? (" " + this.$t('lang.main.filter.or') + " ") : (" " + this.$t('lang.main.filter.and') + " ")) + ")";
            }
        },
        components: {
            AdaptersDialog,
            InputNumber,
            RadioButton,
            Divider,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.cluster.delete_gr_by_filter')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="keysCountMore">{{ $t('lang.cluster.keys_more') }}</label>
                        <InputNumber v-model.number="model.keysCountMore" inputId="keysCountMore" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="keysCountLess">{{ $t('lang.cluster.keys_less') }}</label>
                        <InputNumber v-model.number="model.keysCountLess" inputId="keysCountLess" :min="0" />
                    </div>
                </div>
            </div>
            <p>{{ $t('lang.cluster.dl_gr_ws_main') }}</p>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wsMaxMore">
                            {{ this.isGoogleGny ? $t('lang.cluster.frequency_less') : $t('lang.cluster.ws_more') }}
                        </label>
                        <InputNumber v-model.number="model.wsMaxMore" inputId="wsMaxMore" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wsMaxLess">
                            {{ this.isGoogleGny ? $t('lang.cluster.frequency_less') : $t('lang.cluster.ws_less') }}
                        </label>
                        <InputNumber v-model.number="model.wsMaxLess" inputId="wsMaxLess" :min="0" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wskMaxMore">{{ $t('lang.cluster.wsk_more') }}</label>
                        <InputNumber v-model.number="model.wskMaxMore" inputId="wskMaxMore" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wskMaxLess">{{ $t('lang.cluster.wsk_less') }}</label>
                        <InputNumber v-model.number="model.wskMaxLess" inputId="wskMaxLess" :min="0" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="superwskMaxMore">{{ $t('lang.cluster.superwsk_more') }}</label>
                        <InputNumber v-model.number="model.superwskMaxMore" inputId="superwskMaxMore" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="superwskMaxLess">{{ $t('lang.cluster.superwsk_less') }}</label>
                        <InputNumber v-model.number="model.superwskMaxLess" inputId="superwskMaxLess" :min="0" />
                    </div>
                </div>
            </div>
            <p>{{ $t('lang.cluster.dl_gr_summ_ws') }}</p>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wsSumMore">
                            {{ this.isGoogleGny ? $t('lang.cluster.frequency_less') : $t('lang.cluster.ws_more') }}
                        </label>
                        <InputNumber v-model.number="model.wsSumMore" inputId="wsSumMore" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wsSumLess">
                            {{ this.isGoogleGny ? $t('lang.cluster.frequency_less') : $t('lang.cluster.ws_less') }}
                        </label>
                        <InputNumber v-model.number="model.wsSumLess" inputId="wsSumLess" :min="0" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wskSumMore">{{ $t('lang.cluster.wsk_more') }}</label>
                        <InputNumber v-model.number="model.wskSumMore" inputId="wskSumMore" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="wskSumLess">{{ $t('lang.cluster.wsk_less') }}</label>
                        <InputNumber v-model.number="model.wskSumLess" inputId="wskSumLess" :min="0" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="superwskSumMore">{{ $t('lang.cluster.superwsk_more') }}</label>
                        <InputNumber v-model.number="model.superwskSumMore" inputId="superwskSumMore" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="superwskSumLess">{{ $t('lang.cluster.superwsk_less') }}</label>
                        <InputNumber v-model.number="model.superwskSumLess" inputId="superwskSumLess" :min="0" />
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col">
                    <div class="field">
                        <label>{{filterLabel}}</label>
                        <div class="formgroup-inline">
                            <div class="field-radiobutton">
                                <RadioButton v-model="model.conditionOr" :value="false" inputId="conditionAnd" />
                                <label for="conditionAnd">{{ $t('lang.main.f_rule_and') }}</label>
                            </div>
                            <div class="field-radiobutton">
                                <RadioButton v-model="model.conditionOr" :value="true" inputId="conditionOr" />
                                <label for="conditionOr">{{ $t('lang.main.f_rule_or') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="resultStr">
                <div class="grid">
                    <div class="col">
                        <code>{{ resultStr }}</code>
                    </div>
                </div>
            </template>
            <Divider />
            <div class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_deleted"
                        name="targetNode"
                        :value="-2"
                    />
                    <label for="f_deleted">{{ $t('lang.cluster.f_deleted') }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_unallocated"
                        name="targetNode"
                        :value="-1"
                    />
                    <label for="f_unallocated">{{ $t('lang.cluster.f_unallocated') }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
